import getParentMap from "./get-parent-map";
import getPropertyWrapper from "./get-property-wrapper";
import setComputedInitialProperties from "./set-computed-initial-properties";
import setInitialProperties from "./set-initial-properties";

/**
 * Set the parent property
 * @param {String} parent
 * @param {TriggerProps} trigger
 * @param {StepProps} step
 * @param {MainClassProps | null} main
 */
const setParentStyle = (parent, trigger, step, main) => {
  const data = getPropertyWrapper(parent);
  const fn = data.get("fn");
  const name = data.get("name") || "";
  const isInitial = trigger.get("initial");

  /**
   * Is "initial" trigger, so it's user-set initial property
   * @example `bg(#000)`
   */
  if (isInitial) {
    setInitialProperties(data, main, step, false);

    return null;
  } else {
    /**
     * Property with a trigger. Need to compute the initial, or check if it exists
     * @example `hover:bg(#000)`
     */
    if (main) {
      /** Parent property is not in already-generated initial properties */
      const initial = main.initials.get(name);

      if (!initial || (fn && !initial.has(fn))) {
        setComputedInitialProperties(main, data, name);
      }
    }

    /** Process the parent (with a trigger) property and get layers with all values */
    return getParentMap(data, main, step, trigger);
  }
};

export default setParentStyle;
